import React from 'react';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import styles from './AlertResolutionEmailField.module.css';

interface AlertResolutionEmailFieldProps {
  mode: 'view' | 'edit';
  hasResolutionEmail: boolean;
  onChange?: (checked: boolean) => void;
}

export function AlertResolutionEmailField({
  mode,
  hasResolutionEmail,
  onChange,
}: AlertResolutionEmailFieldProps) {
  const isEdit = mode === 'edit';

  return (
    <Stack>
      <Box className={styles.checkboxContainer}>
        <FormControlLabel
          control={
            <Checkbox
              checked={hasResolutionEmail}
              onChange={(e) => onChange?.(e.target.checked)}
              disabled={!isEdit}
            />
          }
          label={
            <Box className={styles.checkboxLabel}>
              <Typography variant="body2">
                Send email when alert resolves
              </Typography>
            </Box>
          }
        />
      </Box>
      {isEdit && (
        <Typography variant="caption" className={styles.checkboxLabelText}>
          In addition to emails when the alert becomes active, if this option is
          selected this alert will also send a second email to recipients when
          conditions return below the set threshold
        </Typography>
      )}
    </Stack>
  );
}
